import { createContext } from 'react';

const SidebarContext = createContext({ expanded: false });

export const SidebarProvider = SidebarContext.Provider;
export const SidebarConsumer = SidebarContext.Consumer;
export default SidebarContext;
